import api from './api'
import axios from 'axios'
import { development }  from '../contexts/auth'
import { v4 as uuidv4 } from 'uuid';


export async function Authtoken(data) {
	if (data) {
		try {
			var config = {
				headers: { 
					'Content-Type': 'multipart/form-data'
				}
			};
			var dataAppend = new FormData();
			dataAppend.append('token',data);
			const response = await api.post('/auth/token', dataAppend, config)
			if (response.status === 200 && response.data && response.data.access_token) {
				return response.data;
			} else {
				return null;
			}
		} catch (e) {
			return null;
		}
	}
}

export async function Products(token) {
	if (token) {
		try {
			var acesso = false;
			api.defaults.headers.Authorization = `Bearer ${token}`;
			const response = await api.post('/products')
			console.log('response')
			console.log(response)
			if (response.status === 200 && response.data && response.data.products) {
				response.data.products.forEach(products => {
					if (products.title.toLowerCase().includes("motion")) {
						if (products.status === 1) {
							acesso = true;
						}
					}
				});
				return {
					acesso: acesso,
					roles: {
						ia_resources: response.data.resources.ia_resources,
						compliance: response.data.resources.compliance
					},
					user: {}
					};
			} else {
				return {
					acesso: false,
					roles: {},
					user: {}
					};
			}
		} catch (e) {
			console.log(e)
			return {
				acesso: false,
				roles: {},
				user: {}
				};;
		}
	} return false;
}

export async function LogOut(token = "") {
	try {
		api.defaults.headers.Authorization = `Bearer ${token}`;
		await api.post('/logout');
	} catch (error) {}
}

export async function Info(token = "") {
	try {
		api.defaults.headers.Authorization = `Bearer ${token}`;
		const response = await api.post('/me');
		return response.data.user;
	} catch (error) { return null;}
}


export async function getBalance(tokenLocalStorage) {
    try {
		if (development) return 999;
        const response = await get('https://api.reanimate.com.br/api/products/tracker/balance', 'json', tokenLocalStorage);
		console.log(response)
		return response.balance;
    } catch {
		return 0;
    }
}

export async function get(url, type, tokenLocalStorage) {
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${tokenLocalStorage}`,
            }
        });
        
        if (response.status === 401) {
			window.location.replace("https://www.reanimateads.com.br/");
		}

        if (response.ok) {
            switch (type) {
                case 'json':
                    return await response.json();
                case 'text':
                    return await response.text();
            }
    
            return await response.json(); 
    
        } else {
            console.error('Erro na requisição', response.statusText);
            return null;
        }
    } catch (error) {
        console.log(error)
    }
};

export const apiVideo = axios.create({
	baseURL: "https://dynamic-video.reanimate.com.br/"
	//baseURL: "http://localhost:5000/"
})

const api_url = "https://dynamic-video.reanimate.com.br/";
//const api_url = "http://localhost:5000/";

export async function CriarPasta() {
	try {
		console.log("Criando pasta no servidor...");
		var pasta =  await apiVideo.get('/Reanimate/criar-pasta');
		return pasta.data;
	} catch { return null; }
}

export async function EnviarHtmlVideo(videoModel, pasta) {
	try {
		const config = {
			timeout: 5000,
			headers: {
				'Access-Control-Allow-Origin': '*',
			  },
		  };
		var dataAppend = new FormData();
		dataAppend.append('Html', videoModel.html);
		dataAppend.append('Duration', videoModel.duration);
		dataAppend.append('Fps', videoModel.format.toLowerCase() === 'gif' && videoModel.fps > 50 ? 50 : videoModel.fps);
		dataAppend.append('Width', videoModel.width);
		dataAppend.append('Bitrate', videoModel.bitrate);
		dataAppend.append('Height', videoModel.height);
		dataAppend.append('Format', videoModel.format);
		dataAppend.append('Audio', videoModel.format.toLowerCase() === 'gif' ? null : videoModel.audio);
		dataAppend.append('AudioIA', videoModel.format.toLowerCase() === 'gif' ? null :  videoModel.audioIA);
		dataAppend.append('BitFormat', videoModel.bit ? "yuva444p10le" : "yuv420p");
		dataAppend.append('Path', pasta);
		dataAppend.append('GifQuality', videoModel.gifQuality);
		dataAppend.append('Quality', videoModel.quality);		
		try {
			dataAppend.append('Usuario', videoModel.usuario ?? '');
		} catch {}
		
		console.log('enviando html para a api....')
		apiVideo.post('/Reanimate/video-reanimate', dataAppend, config);
		return null;
	} catch { return null; }
}

export async function ReceberVideo(arquivo, videoModel) {
	try {
		const response = await fetch(api_url + `reanimate/receber-video-novo?path=${encodeURIComponent(arquivo)}\\out.${videoModel.format.toLowerCase()}`, {
			method: 'GET',
		});
		console.log('response.ok')
		console.log(response.ok)
		if (!response.ok) {
			console.log('not ok')
			return {
				percentual: 100,
				finalizado: false
			};
		}
		const blob = await response.blob();

		return {
			blob: blob,
			percentual: 100,
			finalizado: true,
			ext: videoModel.format.toLowerCase()
		};
	} catch (error) {
		console.log(error)
		return {
			percentual: 100,
			finalizado: false
		};
	}
}

export async function VerificarStatusVideo(arquivo, videoModel) {
	try {
		const response = await fetch(api_url + `reanimate/verificar-status?path=${encodeURIComponent(arquivo)}\\out.${videoModel.format.toLowerCase()}`, {
			method: 'GET',
		});
		const responseJson = await response.json();
		console.log(responseJson);
		const frames = videoModel.fps * videoModel.duration / 1000;
		return {
			finalizado: responseJson.finalizado,
			percentual: 100 * parseInt(responseJson.percentual) / frames
		}
	} catch {

	}
}

export async function DeletarPasta(path) {
	try {
		console.log("Deletar pasta no servidor...");
		await apiVideo.get('/Reanimate/deletar-pasta?path=' + path);
		return true;
	} catch { return null; }
}